import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Notification } from '../../../common/model/notification';
import { NotificationService } from '../../../common/service/notification.service';
import { isInternalUrl } from '../../../../app/shared/util/string-util';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {

  @Input()
  notification: Notification;
  @Output()
  deleteNotification = new EventEmitter<Notification>();

  isInternalUrl = isInternalUrl;

  constructor(public notificationService: NotificationService) { }

}
